// extracted by mini-css-extract-plugin
module.exports = {"tooltipPercent":"QualityGraph_tooltipPercent__3c8Yv"};